import React, { Component } from "react";
import { Card, CardBody, Button, Col, Row } from "reactstrap";
import {
  SelectInput,
  TextInput,
  SlButton,
  SlPageTitle,
  SlSectionTitle,
  SlFormEntryRow,
  SlMoneyInput,
  SlSectionLabel,
  SlDropdown,
  SlBusyIndicator,
} from "../editors";
import {
  metadataService,
  userService,
  newLoanStepperService,
  workflowService,
  UserBasisApi,
  ProfileApi,
  SessionService,
  FinancialService,
  FinancialApi,
} from "../../_services";
import { connect } from "react-redux";
import  PropTypes  from "prop-types";
import validator from "validator";
import { history } from "../../_helpers";
import {
  registrationActions,
  newLoanActions,
  refinanceIncreaseLoanActions,
  financialInfoActions
} from "../../_actions";
import {
  registrationConstants,
  workflowConstants,
  newLoanConstants,
} from "../../_constants";
import Stepper from "./Stepper";
import qs from "query-string";
import { FinancialInfoView } from "./FinancialInfoView";
import { FinancialInfoForm } from "./FinancialInfoForm";
import { scrollToTop } from "../../utils/scrollToTop";

const FINANCIAL_INFO_PAGE_STATE = {
  DETAILS: "DETAILS",
  EDIT: "EDIT",
};

class FinancialInfo extends Component {
  static displayName = FinancialInfo.name;

  constructor(props) {
    super(props);

    this.state = {
      steps: [],
      currentStep: "",
      pageState: FINANCIAL_INFO_PAGE_STATE.DETAILS,
      formValue: {
        selectedLanguage: userService.getUserLanguage(),

        primaryIncome: "",
        employer: "",
        years: "",
        months: 0,
        address1: "",
        address2: "",
        postalCode: "",
        state: "",
        city: "",
        workNumber: "",
        incomePerPeriod: "",
        payFrequency: "",
        otherIncomeSource: "",
        monthlyOtherIncome: "",
      },
      isEdit: false,
      readOnly: false,
      primaryIncomeError: false,
      employerError: false,
      employerZipError: false,
      employerStateError: false,
      employerCityError: false,
      workPhoneError: false,
      incomePerPeriodError: false,
      payFrequencyError: false,
      otherIncomeSourceError: false,
      monthlyOtherIncomeError: false,
      fieldErrors: [],
      requiredFields: [],
      visibleFields: [],
      otherIncomeSourceOpen: false,
      payFrequencyOpen: false,
      employerStateOpen: false,
      employmentStatusOpen: false,
      isBusy: false,
      editedIndex: null,
      editedFinancial: null,
      workflowId: null,
    };

    this.onRemoveFinancial = this.onRemoveFinancial.bind(this);
    this.onEditFinancial = this.onEditFinancial.bind(this);
    this.onAddFinancial = this.onAddFinancial.bind(this);
    this.onNext = this.onNext.bind(this);
  }
  componentDidMount() {
    const { incomes, employers } = this.props;
    let newState = {
      ...this.state,
    };
    if (this.props.location && this.props.location.search) {
      const edit =
        new URLSearchParams(this.props.location.search)
          .get("edit")
          .toLowerCase() === "true";
      if (edit === true) {
        newState.isEdit = edit;
      }
    }
    if (
      (!incomes || incomes.length === 0) &&
      (!employers || employers.length === 0)
    ) {
      this.props.loadFinancialsFromSession();
    }
    let workflowData = workflowService.getCurrentWorkflowStepData();
    if (workflowData) {
      let steps = newLoanStepperService(workflowData.workflowId);
      let currentStep = workflowData.currentStepperStep;
      newState = {
        ...newState,
        steps: steps,
        currentStep: currentStep,
        workflowId: workflowData.workflowId,
      };
    }
    this.setState(newState);
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageState !== this.state.pageState) {
      scrollToTop();
    }
  }

   
  handleBack = () => {
    this.props.onBack();
  };
  onAddFinancial = (formValue) => {
    const { addEmployer, updateEmployer, addIncome, updateIncome } = this.props;
    const { editedFinancial } = this.state;
    let financialInfo = {
      confirmationSummaryScreen: this.props.confirmationSummaryScreen,
      employerName:
        !formValue.employerName &&
        formValue.primaryIncome ==
          FinancialService.PRIMARY_INCOME_SOURCE_SELFEMPLOYED
          ? metadataService.getLookupText(
              "incomeSource",
              formValue.primaryIncome
            )
          : formValue.employerName,
      years: formValue.years,
      months: formValue.months,
      address1: formValue.address1,
      address2: formValue.address2,
      postalCode: formValue.postalCode,
      state: formValue.state,
      city: formValue.city,
      workNumber: formValue.workNumber,
      incomePerPeriod: formValue.incomePerPeriod,
      payFrequency:
        formValue.primaryIncome ===
        FinancialService.PRIMARY_INCOME_SOURCE_NOTEMPLOYED
          ? FinancialService.PAY_FREQUENCY_MONTHLY
          : formValue.payFrequency, // monthly
      otherIncomeSource: formValue.otherIncomeSource,
      monthlyOtherIncome: formValue.monthlyOtherIncome,
      primaryIncome: parseInt(formValue.primaryIncome, 10),
      primaryIncomeSource: parseInt(formValue.primaryIncome, 10),
      amount: formValue.monthlyOtherIncome,
    };
    if (editedFinancial != null) {
      financialInfo.id = editedFinancial.id;
      if (
        editedFinancial.primaryIncome ===
        FinancialService.PRIMARY_INCOME_SOURCE_NOTEMPLOYED
      ) {
        if (
          financialInfo.primaryIncome !==
          FinancialService.PRIMARY_INCOME_SOURCE_NOTEMPLOYED
        ) {
          addEmployer(financialInfo);
          updateIncome({ ...editedFinancial, isDelete: true });
        } else {
          updateIncome(financialInfo);
        }
      } else {
        if (
          financialInfo.primaryIncome ===
          FinancialService.PRIMARY_INCOME_SOURCE_NOTEMPLOYED
        ) {
          addIncome(financialInfo);
          updateEmployer({ ...editedFinancial, isDelete: true });
        } else {
          updateEmployer(financialInfo);
        }
      }
    } else {
      if (
        financialInfo.primaryIncome ===
        FinancialService.PRIMARY_INCOME_SOURCE_NOTEMPLOYED
      ) {
        //
        addIncome(financialInfo);
      } else {
        addEmployer(financialInfo);
      }
    }
    this.setState({
      pageState: FINANCIAL_INFO_PAGE_STATE.DETAILS,
      formValue: {},
      editedFinancial: null,
    });
    this.props.onFinancialInfoClose();
  };
  onRemoveFinancial = (selected) => {
    const {
      removeEmployer,
      removeIncome,
      loggedIn,
      updateEmployer,
      updateIncome,
    } = this.props;
    if (loggedIn == true) {
      if (
        selected.primaryIncome !==
        FinancialService.PRIMARY_INCOME_SOURCE_NOTEMPLOYED
      ) {
        updateEmployer({ ...selected, isDelete: true });
      } else {
        updateIncome({ ...selected, isDelete: true });
      }
    } else {
      if (
        selected.primaryIncome !==
        FinancialService.PRIMARY_INCOME_SOURCE_NOTEMPLOYED
      ) {
        removeEmployer(selected.id);
      } else {
        removeIncome(selected.id);
      }
    }
  };
  onEditFinancial = (editedFinancial) => {
    const formValue = {
      ...editedFinancial,
      monthlyOtherIncome: editedFinancial.monthlyOtherIncome
        ? editedFinancial.monthlyOtherIncome
        : editedFinancial.amount,
    };
    this.setState({
      formValue: formValue,
      pageState: FINANCIAL_INFO_PAGE_STATE.EDIT,
      editedFinancial: editedFinancial,
    });
    this.props.onFinancialInfoOpen();
  };
  onCancelAddFinancial = () => {
    this.setState({
      pageState: FINANCIAL_INFO_PAGE_STATE.DETAILS,
      editedFinancial: null,
      formValue: {},
    });
    this.props.onFinancialInfoClose();
  };
  onNext = () => {
    if (this.props.loggedIn) {
      history.push("/my-profile");
    }
    if (this.state.isEdit) {
      const {workflowId} = this.state;
      if (
        workflowId ===
          workflowConstants.REFINANCE_INCREASE_LOAN_DISABLED_FUNDING_WORKFLOW ||
        workflowId ===
          workflowConstants.REFINANCE_INCREASE_LOAN_WORKFLOW
      ) {
        history.push("/Refinance/Summary");
      } else {
        history.push("/ConfirmationSummary");
      }
    } else {
      this.props.onNext();
    }
  };
  render() {
    const {
      employers,
      incomes,
      steps,
      currentStep,
      loggedIn,
      displayNextBackButtons,
    } = this.props;
    const { pageState, formValue, isEdit, workflowId } = this.state;

    return (
      <div className="FinancialInfo">
        {steps && currentStep && (
          <Stepper
            stepData={this.props.steps}
            currentStep={this.props.currentStep}
          />
        )}
        {workflowId == workflowConstants.NEW_LOAN_WORKFLOW ||
        workflowId == workflowConstants.REFINANCE_INCREASE_LOAN_WORKFLOW ||
        workflowId == workflowConstants.NEW_LOAN_LOGGED_IN_WORKFLOW ? (
          <SlFormEntryRow>
            <SlPageTitle pageName="YourFinances" />
            <h6 className="text-center pt-3 pb-3 mb-3">
              {metadataService.getTitle("PleadAddSourceIncome")}
            </h6>
          </SlFormEntryRow>
        ) : (
          <SlPageTitle pageName="MyIncome" />
        )}

        {pageState === FINANCIAL_INFO_PAGE_STATE.DETAILS && (
          <div>
            <FinancialInfoView
              onAdd={() => {
                this.setState({ pageState: FINANCIAL_INFO_PAGE_STATE.EDIT });
                this.props.onFinancialInfoOpen();
              }}
              onRemove={this.onRemoveFinancial}
              onEdit={this.onEditFinancial}
              showOnAdd={true}
            />
            {displayNextBackButtons && (
              <SlFormEntryRow>
                <div className="text-center">
                  {isEdit == true ? (
                    <SlButton
                      name={"Save"}
                      onClick={this.onNext}
                      disabled={
                        (!employers || employers.length == 0) &&
                        (!incomes || incomes.length == 0)
                      }
                    />
                  ) : (
                    <div className="display-flex">
                      <div className="half-width">
                        <SlButton
                          cssClass={"backBtn"}
                          name="Back"
                          onClick={this.handleBack}
                        />
                      </div>
                      <div className="half-width">
                        <SlButton
                          name="Next"
                          onClick={this.onNext}
                          disabled={
                            (!employers || employers.length == 0) &&
                            (!incomes || incomes.length == 0)
                          }
                        />
                      </div>
                    </div>
                  )}
                </div>
              </SlFormEntryRow>
            )}
          </div>
        )}
        {pageState === FINANCIAL_INFO_PAGE_STATE.EDIT && (
          <div>
            <FinancialInfoForm
              source={formValue}
              onBack={this.onCancelAddFinancial}
              onSubmit={this.onAddFinancial}
            />
          </div>
        )}
      </div>
    );
  }
}

FinancialInfo.propTypes = {
  onChange: PropTypes.func,
  addFinancial: PropTypes.func,
  updateFinancial: PropTypes.func,
  displayNextBackButtons : PropTypes.bool
};
FinancialInfo.defaultProps = {
  displayNextBackButtons : true,
}

function mapStateToProps(state) {
  const { loggedIn } = state.authentication;
  const { steps, currentStep } = state.users;
  const { 
    employers,
    incomes,
   } = state.financialInfo;
 
  const {
    confirmationSummaryScreen,
    error,
    language,
    step,
    completedSteps,    
  } = state.registration;

  return {
    loggedIn,
    confirmationSummaryScreen,
    error,
    language,
    completedSteps,
    steps,
    currentStep,
    step, 
    employers : employers.map(s=>{
        s.primaryIncome = s.primaryIncomeSource
      return s;
    }),
    incomes,
  };
}
const mapDispatchToProps = (dispatch) => {
  return {
    addFinancial: (financial) => {
      dispatch(financialInfoActions.addFinancial(financial));
    },
    updateFinancial: (financial,index) => {
      dispatch(financialInfoActions.updateFinancial(financial,index));
    },
    addEmployer: (employer) => {
      dispatch(financialInfoActions.addEmployer(employer));
    },
    updateEmployer: (employer) => {
      dispatch(financialInfoActions.updateEmployer(employer));
    },
    removeEmployer: (id) => {
      dispatch(financialInfoActions.removeEmployer(id));
    },
    addIncome: (income) => {
      dispatch(financialInfoActions.addIncome(income));
    },
    updateIncome: (income) => {
      dispatch(financialInfoActions.updateIncome(income));
    },
    removeIncome: (id) => {
      dispatch(financialInfoActions.removeIncome(id));
    },
    onNext: () => {
      dispatch(registrationActions.handleFinancialInformationNextRequest())
    },
    loadFinancialsFromSession: () => {
      dispatch(financialInfoActions.loadFinancialsFromSession())
    },
    onFinancialInfoOpen: () => {
      dispatch(financialInfoActions.onFinancialInfoOpen())
    },
    onFinancialInfoClose: () => {
      dispatch(financialInfoActions.onFinancialInfoClose())
    },
    onBack: () => {
      dispatch(registrationActions.handleFinancialInformationBackRequest());
    },
  };
};
const connectedFinancialInfo = connect(mapStateToProps,mapDispatchToProps)(FinancialInfo);
export { connectedFinancialInfo as FinancialInfo };
